import { useCustomSuspenseQuery } from "@/hooks/use-graphql-client";

import { NewDayTripPlan_Default_EditPage_Query } from "./query";

type Props = {
	hotelID: string;
	planID: string | undefined;
};

export const useDayTripPlanEditQuery = ({ hotelID, planID }: Props) => {
	const { data } = useCustomSuspenseQuery(NewDayTripPlan_Default_EditPage_Query, {
		variables: { hotelID, duplicatePlanID: planID },
		fetchPolicy: "no-cache",
	});

	return data;
};
